module.exports = __webpack_public_path__ + "img/pin-empreendedor.ded527ff.png";